/* global VXConfig */

import React        from 'react';
import PropTypes    from 'prop-types';
import OfferIcon    from './SubComponents/OfferIcon';
import Translations from '../../utils/Translations';

const DailybonusTommorowItem = props => {

	const {free = false, offer, purchased} = props.data;

	// For mysterious offer logo image height set in jsx, cause this fixes case
	// with too big mysterious offer logo after changing less in dev on the mobile
	return (
		<div className={'dailybonus-tommorow-item' + (props.showMysteriousOffer || VXConfig.dailyBonusShowMysteriousOffer ? ' -show-mysterious-offer' : '')}>
			<div className={'dailybonus-tommorow-item__headline' + (VXConfig.isVXMobilePlatform ? ' dailybonus__mobile--item__headline' : '')}>
				<h3>{VXConfig.isVXMobilePlatform && <OfferIcon offer={offer} purchased={purchased} />}
					{Translations.get('TommorowHeadLine')}
				</h3>
			</div>
			{!VXConfig.isVXMobilePlatform && (
				<div className="dailybonus-tommorow-item__headline -small">
					{Translations.get('TommorowHeadLineShort')}
				</div>
			)}
			<div className="dailybonus-tommorow-item__wrapper -tomorrow-offer">
				<div className="dailybonus-tommorow-item__title"
				     dangerouslySetInnerHTML={{
					     __html:
						     Translations.get((free ? 'TommorowTitle_Free_' : 'TommorowTitle_') + offer),
				     }}
				/>
				<div className="dailybonus-tommorow-item__icon"><OfferIcon offer={offer} purchased={purchased} /></div>
				<div className="dailybonus-tommorow-item__description"
				     dangerouslySetInnerHTML={{__html: Translations.get(`TommorowDescription`)}}
				/>
			</div>


			<div className="dailybonus-tommorow-item__wrapper -tomorrow-mysterious-offer">
				<img className='dailybonus-tommorow-item__mysterious_offer-logo' height='90px'
				     src="/assets/img/special_events/Dailybonus/mystery-box-365-kalender.svg"
					 loading={props.lazyImageLoading ? 'lazy' : 'eager'}
				/>
				<div className='dailybonus-tommorow-item__mysterious_offer'>{Translations.get('TomorrowMysteriousOfferTitle')}</div>
			</div>
		</div>
	);
};

DailybonusTommorowItem.propTypes = {
	data:                PropTypes.object.isRequired,
	showMysteriousOffer: PropTypes.bool,
	lazyImageLoading:    PropTypes.bool,
};

DailybonusTommorowItem.defaultProps = {
	showMysteriousOffer: false,
	lazyImageLoading:    false,
};

export default DailybonusTommorowItem;
